import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {setTitle} from "../shared/App/actions";
import CategoryForm from "./CategoryForm";
import {Redirect, useParams} from "react-router-dom";
import {APIRequest} from "../shared/APIRequest";
import {notification} from "antd";

const CategoryFormCreate = () => {
    const dispatch = useDispatch();
    const [redirect, setRedirect] = useState();

    const {id} = useParams();

    useEffect(() => {
        dispatch(setTitle('Formularz dodawania kategorii'));
    }, [dispatch, id]);

    const handleCreate = (values) => {
        APIRequest.post('category', values, (message) => {
            notification.success({
                message: 'Akcja zakończona powodzeniem'
            });
            setTimeout(() => {
                setRedirect(message._links.redirect);
            }, 2000)

        });
    };

    if (redirect) {
        return <Redirect to={redirect}/>
    }
    return (
        <CategoryForm onSubmit={handleCreate} payload={{}}/>
    )
};

export {CategoryFormCreate as default}